<script>
import ComiteConvivencia from "@/components/estandares/Comite/comite-convivencia";
import Layout from "@/views/layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";

/**
 * Form elements component
 */
export default {
  page: {
    title: "1.1.8 Comité de Convivencia",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    ComiteConvivencia,
  },
  data() {
    return {
      title: "1.1.8 Comité de Convivencia",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "1.1.8 Comité de Convivencia",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id}/conformacion-comite-convivencia`,
        },
        {
          text: "Conformación de Comité de Convivencia",
          active: true,
        },
      ],

      committeeID: this.$route.params.comite || 0,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <ComiteConvivencia
          :companyID="Number(companyID)"
          :committeeID="Number(committeeID)"
        />
      </div>
    </div>
  </Layout>
</template>
